import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import ServicioArchivos from "../../servicios/ServicioArchivos";
import ServicioObjetos from "../../servicios/ServicioObjetos";
import formatoEspanolEsMX from "../../servicios/ServicioIdiomaFecha";

const Formulario = (props) => {

    const { emisor, emisores, trabajador, asignarValores, asignarEmisor, buscarRecibos, buscarLike, growl } = props;
    const defaultValues = {
        emisor: '',
        fechaInicial: '',
        fechaFinal: '',
        trabajador: ''
    }

    const { control, formState: { errors }, handleSubmit, reset, setValue } = useForm({ defaultValues });


    const onSubmit = (data, extra) => {
        let fechas = [
            data.fechaInicial,
            data.fechaFinal
        ]
        let restricciones = { "alias_elEmisor.rfc": data.emisor.rfc };
        if (!ServicioObjetos.esObjetoVacio(data.trabajador)) {
            restricciones["alias_elTrabajador.rfc"] = data.trabajador;
        }
        let pagina = {
            join: {
                "trNominas": "trNominas",
                "alias_trNominas.tcEmisor": "elEmisor",
                "alias_trNominas.tcTrabajador": "elTrabajador"
            }, restricciones: restricciones,
            between: fechas,
            nombrePropiedadBetween: "fechaPago",
            orderDesc: extra
        };
        ServicioArchivos.descargaArchivo('/cfdi/descarga_masiva.json', pagina)
            .then((response) => {
                if (response !== "si")
                    return growl.show({ severity: 'error', summary: '', detail: response });
            });

    };

    const getFormErrorMessage = (name) => {
        return errors[name] && <Message severity="error" text={errors[name].message} />
    };

    const cargaEmisor = (e) => {
        setValue("emisor", e.value);
    }

    const cargaTrabajador = (e) => {
        setValue("trabajador", e.target.value);
    }

    return (<>
        <form className="p-fluid">
            <div className="p-fluid p-grid">
                <div className="p-col-12 p-md-2">* Seleciona un emisor</div>
                <div className="p-col-12 p-md-7">
                    <Controller name="emisor" control={control} rules={{ required: 'Emisor es requerida.' }} render={({ field, fieldState }) => (
                        <Dropdown appendTo={document.body} dataKey="id" value={emisor} options={emisores}
                            onChange={(e) => { asignarEmisor({ emisor: e.value }); cargaEmisor(e) }}
                            placeholder="Selecione un emisor" optionLabel="nombre" autoWidth={false} autoFocus />
                    )} />
                    {getFormErrorMessage('emisor')}
                </div>
                <div className="p-col-12 p-md-3"><Button type="button" label="Buscar Recibos" icon="pi-md-search" onClick={(e) => { buscarRecibos(true) }} /></div>
            </div>
            <br />
            <div className="p-fluid p-grid">
                <div className="p-col-12 p-md-4">
                    <label htmlFor="buscarEmpleado">*Buscar empleado</label>
                    <Controller name="emisor" control={control} render={({ field, fieldState }) => (
                        <InputText className="p-inputtext" placeholder="Buscar por nombre de trabajador o por rfc de trabajador" name="trabajador.nombre" value={trabajador.nombre || ''}
                            onChange={(e) => { asignarValores(e); cargaTrabajador(e) }} onKeyUp={buscarLike} />
                    )} />
                </div>
                <div className="p-col-12 p-md-4">
                    <label htmlFor="fechaInicial" className={errors.fechaInicial ? 'p-error' : ''}>*Fecha Inicial</label>
                    <Controller locale={formatoEspanolEsMX} name="fechaInicial" control={control} rules={{ required: 'Fecha inicial es requerida.' }} render={({ field, fieldState }) => (
                        <Calendar id={field.name} {...field} className={fieldState.invalid ? 'p-error' : ''} />
                    )} />

                    {getFormErrorMessage('fechaInicial')}
                </div>
                <div className="p-col-12 p-md-4">
                    <label htmlFor="fechaFinal" className={errors.fechaFinal ? 'p-error' : ''}>*Fecha Inicial</label>
                    <Controller name="fechaFinal" control={control} rules={{ required: 'Fecha final es requerida.' }} render={({ field, fieldState }) => (
                        <Calendar locale={formatoEspanolEsMX} id={field.name} {...field} className={fieldState.invalid ? 'p-error' : ''} />
                    )} />
                    {getFormErrorMessage('fechaFinal')}
                </div>
                <div className="p-col-12 p-md-6">
                    <Button type="button" label="Descarga XML" className="p-button-warning" onClick={handleSubmit((data) => onSubmit(data, "xmls"))} />
                </div>
                <div className="p-col-12 p-md-6">
                    <Button type="button" label="Descarga PDF" className="p-button-info" onClick={handleSubmit((data) => onSubmit(data, "pdfs"))} />
                </div>
            </div>
        </form>
    </>);
}

export default Formulario;